import React, { PropsWithChildren } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { FONT_GSS_FUTURA_BOOK } from '@monorepo/shared/src/themes/defaultTheme';

type Props = {
  children?: React.ReactNode;
};

const TabHeading: React.FC<PropsWithChildren<Props>> = ({ children }) => {
  const classes = useStyles();

  return <div className={classes.div}>{children}</div>;
};

const useStyles = makeStyles((theme: any) => {
  return {
    div: {
      alignItems: 'center',
      borderBottom: `1px solid ${(theme.palette as any).grey[500]}`,

      borderLeft: `1px solid ${(theme.palette as any).grey[500]}`,
      borderRight: `1px solid ${(theme.palette as any).grey[500]}`,
      display: 'inline-flex',
      color: theme.palette.black.main,
      flexDirection: 'row',
      '& a': {
        color: theme.palette.black.main,
        textDecoration: 'none',
      },
      '& svg': {
        height: '1.5rem',
        marginRight: '1rem',
        width: 'auto',
      },
      fontFamily: FONT_GSS_FUTURA_BOOK,
      fontSize: '1.25rem',
      fontStyle: 'normal',
      fontWeight: 'bold',
      justifyContent: 'center',
      lineHeight: '1.875rem',
      maxWidth: 'none',
      minHeight: '60px',
      textDecoration: 'none',
      textTransform: 'capitalize',
      width: '100%',
    },
  };
});

export default TabHeading;
